import { createSlice } from "@reduxjs/toolkit";
import { getOneMonthRangeMinus } from "../../utility/util";

export const initFilterValue = {
  absenceDate: getOneMonthRangeMinus(new Date()),
  absenceDateTo: new Date(),
  organizationType: "",
  organizationUnit: [],
  workerlist: [],
  absencegroup: "",
};

const initialState = {
  filterValue: initFilterValue,
};

export const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    setScheduleFilterValue: (state, action) => {
      state.filterValue = {
        ...state.filterValue,
        ...action.payload,
      };
    },
  },
});

export const { setScheduleFilterValue } = scheduleSlice.actions;
export default scheduleSlice.reducer;
